<template>
  <div v-if="loadingPage">
    <v-card class="ma-sm-3">
      <v-progress-linear
        color="primary"
        :indeterminate="loadingPage"
      ></v-progress-linear>
    </v-card>
  </div>
  <div v-else>
    <!-- Parameters -->
    <v-card class="ma-sm-3" outlined>
      <v-card-title
        class="grey lighten-3"
        @click="showParameters = !showParameters"
      >
        <v-icon>
          {{ showParameters ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
        Parameters
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="mt-2" v-show="showParameters">
          <v-row>
            <!-- General -->
            <v-col cols="12" sm="6" md="4" order="1" order-sm="1" class="mt-2">
              <v-card outlined>
                <v-card-title class="text-subtitle-2 grey lighten-4 text-break">
                  <v-icon> mdi-magnify </v-icon> General
                </v-card-title>
                <v-card-text>
                  <v-col cols="12" >
                    <v-row
                      v-for="header in headersParametersGeneral"
                      v-show="!hide[header.value]"
                      :key="header.value"
                      no-gutters
                    >
                      <v-col cols="header.cols"> 
                        <SearchInputFieldsSelector
                          :header="header"
                          :headerSelects="headerSelects"
                          :searchPassed="search"
                          v-on:updateParent="addToSearch"
                          v-on:doOnClick="doOnClick"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
            <!-- Responsables -->
            <v-col cols="12" sm="6" md="4" order="1" order-sm="1" class="mt-2">
              <v-card outlined>
                <v-card-title class="text-subtitle-2 grey lighten-4 text-break">
                  <v-icon>mdi-star</v-icon> Responsables
                </v-card-title>
                <v-card-text>
                  <v-col cols="12" sm="12">
                    <v-row
                      v-for="header in headersParametersResponsables"
                      :key="header.value"
                      v-show="!hide[header.value]"
                      no-gutters
                    >
                      <v-col cols="header.cols"> 
                        <SearchInputFieldsSelector
                          :header="header"
                          :headerSelects="headerSelects"
                          :searchPassed="search"
                          v-on:updateParent="addToSearch"
                          v-on:doOnClick="doOnClick"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
            <!-- Date Specifications -->
            <v-col cols="12" sm="6" md="4" order="1" order-sm="1" class="mt-2">
              <DateSpecifications
                :searchPassed="search"
                v-on:searchDates="addToSearch"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
    </v-card>
    <!-- Models&Parts -->
    <v-card class="ma-sm-3" outlined>
      <v-card-title
        class="grey lighten-3"
        @click="showModelsAndParts = !showModelsAndParts"
      >
        <v-icon>{{
          showModelsAndParts ? "mdi-chevron-up" : "mdi-chevron-down"
        }}</v-icon>
        Models & Parts
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="mt-2" v-show="showModelsAndParts">
          <v-row>
            <!-- General -->
            <v-col cols="12" md="8" order="1" order-sm="1" class="mt-2">
              <ModelsAndPartsGeneral 
                :searchPassed="search"
                :headerSelects="headerSelects"
              />
            </v-col>
            <!-- Service Costs -->
            <v-col cols="12" md="4" order="2" order-sm="2" class="mt-2">
              <v-card outlined>
                <v-card-title class="text-subtitle-2 grey lighten-4 text-break">
                  <v-icon>mdi-magnify</v-icon> Service Costs
                </v-card-title>
                <v-card-text>
                  <v-col cols="12" sm="12">
                    <v-row
                      v-for="header in headersModelsAndPartsServiceCosts"
                      :key="header.value"
                      v-show="!hide[header.value]"
                      no-gutters
                    >
                      <v-col cols="header.cols"> 
                        <SearchInputFieldsSelector
                          :header="header"
                          :headerSelects="headerSelects"
                          :searchPassed="search"
                          v-on:updateParent="addToSearch"
                          v-on:doOnClick="doOnClick"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
    </v-card>
    <!-- Products -->
    <v-card class="ma-sm-3" outlined>
      <v-card-title
        class="grey lighten-3"
        @click="showProducts = !showProducts"
      >
        <v-icon>{{
          showProducts ? "mdi-chevron-up" : "mdi-chevron-down"
        }}</v-icon>
        Products
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="mt-2" v-show="showProducts">
          <v-row>
            <v-col
              v-for="header in headersProducts"
              :key="header.value"
              :cols="header.cols.cols"
              :sm="header.cols.sm != undefined ? header.cols.sm : header.cols.cols"
              :md="header.cols.md"
              class="mt-2"
            >
              <v-card outlined>
                <v-card-title class="text-subtitle-2 grey lighten-4 text-break">
                  <v-icon>{{ header.icon }}</v-icon> {{ header.text }}
                </v-card-title>
                <v-card-text>
                  <v-col cols="12" sm="12">
                    <v-row>
                      <v-col
                        v-for="check in headerSelects[header.value]"
                        :key="check.value + check.text"
                        no-gutters
                        :cols="header.checkboxCols.cols"
                        :sm="header.checkboxCols.sm != undefined ? header.checkboxCols.sm : header.checkboxCols.cols"
                        :md="header.checkboxCols.md"
                        class="pa-0"
                      >
                        <v-checkbox
                          multiple
                          v-model="temp[header.value]"
                          hide-details="auto"
                          :label="check.text"
                          :value="check.value"
                          no-gutters
                        >
                        </v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
    </v-card>
    <!-- Search Button -->
    <v-card class="ma-sm-3" outlined>
      <v-btn
        width="100%"
        color="primary"
        :loading="loading"
        @click="getAdvancedSearchData"
      >
        <v-card-title>
          <v-icon>
            {{ "mdi-magnify" }}
          </v-icon>
        </v-card-title>
      </v-btn>
    </v-card>
    <!-- Search Results -->
    <DataTable title="Advanced Search"
      :loading="loading"
      :optionsPassed="options"
      :totalEsvs="totalEsvs"
      :esvs="esvs"
      :searchPassed="search"
      :headerSelects="headerSelects"
      :headersTable="headersTable"
      :allowIgnoreServiceLimitTIme="$can('DisplayAll', 'ESVDatatable')"
    v-on:getEsvs="getAdvancedSearchDataTable">
      <template #headerButtons>
        <v-btn
          color="success"
          class="ml-2"
          small
          v-if="$can('ExportToExcel', 'Overview')"
          @click="download"
          :loading="downloadLoading"
        >
          <v-icon left>mdi-export</v-icon>
          Export to Excel
        </v-btn>
      </template>

    </DataTable>
  </div>
</template>

<script>
import SearchInputFieldsSelector from "@/components/Search/SearchInputFieldsSelector.vue";
import DataTable from "@/components/ESV/DataTable.vue";
import DateSpecifications from "@/components/Search/Advanced/DateSpecifications.vue";
import ModelsAndPartsGeneral from "@/components/Search/Advanced/ModelsAndPartsGeneral.vue";

export default {
  name: "Search",
  components: {
    DataTable,
    DateSpecifications,
    SearchInputFieldsSelector,
    ModelsAndPartsGeneral,
  },
  data: () => ({
    showParameters: false,
    showModelsAndParts: false,
    showProducts: false,
    // searchingForModels: true,
    ignoreServiceLimitTime: false,
    loadingSetup: true,
    loadingData: true,
    loadingPage: true,
    downloadLoading: false,
    temp: [
      { productGroups: [] },
      { productSubGroups: [] },
    ],
    hide: { factoryName: true, responsiblePartyOrganisation: true },
    headersParametersGeneral: [
      {
        text: "Dossier",
        value: "dossier",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Subject",
        value: "subject",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Detail Of Trouble",
        value: "detailOfTrouble",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Countermeasure",
        value: "countermeasure",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "SV Reference",
        value: "svReference",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Service Grade",
        value: "serviceGrade",
        type: "select",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Status",
        value: "status",
        type: "select",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
    ],
    headersParametersResponsables: [
      {
        text: "Issuing Party",
        value: "issuingParty",
        type: "autocomplete",
        onChange: false,
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Responsible Party",
        value: "responsibleParty",
        type: "select",
        onChange: true,
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "SV Issuing Party",
        value: "svIssuingParty",
        type: "autocomplete",
        onChange: false,
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Factory Name",
        value: "factoryName",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Responsible Party Organisation",
        value: "responsiblePartyOrganisation",
        type: "autocomplete",
        onChange: false,
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "",
        value: "emptyLineResponsables",
        type: "emptyLine",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Executed By",
        value: "executedBy",
        type: "autocomplete",
        onChange: false,
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Checked By",
        value: "checkedBy",
        type: "autocomplete",
        onChange: false,
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Approved By",
        value: "approvedBy",
        type: "autocomplete",
        onChange: false,
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
    ],
    headersModelsAndPartsServiceCosts: [
      {
        text: "PSL Number",
        value: "pslNumber",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Template Number",
        value: "templateNumber",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Claim Reference",
        value: "claimReference",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Actual Cost",
        value: "actualCost",
        type: "select",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Labour Cost",
        value: "labourCost",
        type: "text",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Currency",
        value: "currency",
        type: "autocomplete",
        cols: "12",
        class: "text-subtitle-1 font-weight-bold",
      },
    ],
    headersProducts: [
      {
        text: "Product Groups",
        value: "productGroups",
        icon: "mdi-flag",
        type: "checkbox",
        cols: {
          'cols':  "12",
          'md': "3",
        },
        checkboxCols: {
          'cols' : "12",
          'sm' : "6",
          'md' : "12",
        },
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Product Sub Groups",
        value: "productSubGroups",
        icon: "mdi-flag",
        type: "checkbox",
        cols: {
          'cols' : "12",
          'md' : "9",
        },
        checkboxCols: {
          'cols' : "12",
          'sm' : "6",
          'md' : "3",
        },
        class: "text-subtitle-1 font-weight-bold",
      },
    ],
    esvs: [],
    // searchTable: [],
    search: [],
    options: { /*itemsPerPage: 15*/sortBy: ['esvReference'], sortDesc: ['false'] },
    totalEsvs: null,
    headerSelects: [
      { serviceRequestType: [] }, 
      { serviceGrade: [] },
      { productGroup: [] },
      { productSubGroup: [] }, 
      { issuingParty: [] }
    ],
    headersTable: [
      {
        text: "Service request type",
        value: "serviceRequestType",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Dossier",
        value: "esvReference",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Description",
        value: "subject",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Service Grade",
        value: "serviceGrade",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Product Group",
        value: "productGroup",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Product Sub Group",
        value: "productSubGroup",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
    ],
  }),
  computed: {
    loading() {
      return this.loadingSetup || this.loadingData;
    },
  },
  methods: {
    getAdvancedSearchSetup() {
      this.loadingSetup = true;
      this.$api
        .getAdvancedSearch()
        .then((resp) => {
          // console.log("AdvancedSearchSetup: ",resp.data);
          this.headerSelects["status"] = resp.data.availableStatusses;
          this.headerSelects["serviceGrade"] = resp.data.availableServiceGrades;
          this.headerSelects["responsibleParty"] =
            resp.data.availableResponsibleParties;
          this.headerSelects["issuingParty"] =
            resp.data.availableIssuingParties;
          this.headerSelects["svIssuingParty"] =
            resp.data.availableSVIssuingParties;
          this.headerSelects["responsiblePartyOrganisation"] =
            resp.data.availableResponsiblePartyOrganisations;
          this.headerSelects["executedBy"] = resp.data.availableUsers;
          this.headerSelects["checkedBy"] = resp.data.availableUsers;
          this.headerSelects["approvedBy"] = resp.data.availableUsers;
          this.headerSelects["actualCost"] = resp.data.availableActualCosts;
          this.headerSelects["currency"] = resp.data.availableCurrencies;
          this.headerSelects["productGroups"] =
            resp.data.availableProductGroups;
          this.headerSelects["productSubGroups"] =
            resp.data.availableProductSubGroups;
        })
        .finally(() => {
          this.loadingSetup = false;
          this.loadingPage = false;
        });
    },
    getAdvancedSearchDataTable(tableSearch){
      this.search = {...this.search, ...tableSearch.search }
      // this.searchTable = tableSearch.search;
      this.options = tableSearch.options;
      this.ignoreServiceLimitTime = tableSearch.ignoreServiceLimitTime;
      this.getAdvancedSearchData();
    },
    getAdvancedSearchData() {
      this.loadingData = true;
      this.refactorArraysToStrings();
      this.$api
        .getAdvancedSearchData(this.options, this.search, this.ignoreServiceLimitTime)
        .then((resp) => {
          this.esvs = resp.data.esvs;
          this.totalEsvs = resp.data.totalEsvs;
        })
        .finally(() => (this.loadingData = false));
    },
    refactorArraysToStrings() {
      if (
        this.arrayIsNotUndefinedOrArrayLengthIsNot0(this.temp["productGroups"])
      ) {
        this.search["productGroups"] = this.fromArrayToSearchString(
          this.temp["productGroups"]
        );
      } else {
        this.search["productGroups"] = "";
      }

      if (
        this.arrayIsNotUndefinedOrArrayLengthIsNot0(
          this.temp["productSubGroups"]
        )
      ) {
        this.search["productSubGroups"] = this.fromArrayToSearchString(
          this.temp["productSubGroups"]
        );
      } else {
        this.search["productSubGroups"] = "";
      }

      if (
        this.arrayIsNotUndefinedOrArrayLengthIsNot0(
          this.headerSelects["selectedModelNames"]
        )
      ) {
        this.search["modelNames"] = this.fromArrayToSearchString(
          this.headerSelects["selectedModelNames"]
        );
      } else {
        this.search["modelNames"] = "";
      }

      if (
        this.arrayIsNotUndefinedOrArrayLengthIsNot0(
          this.headerSelects["selectedPartNames"]
        )
      ) {
        this.search["partNameConcatenation"] = this.fromArrayToSearchString(
          this.headerSelects["selectedPartNames"]
        );
      } else {
        this.search["partNameConcatenation"] = "";
      }
    },
    routeToEsv(esv) {
      this.$router.push({ name: "ESV", params: { esvId: esv.id } });
    },
    doOnClick(valueName) {
      if (valueName === "responsibleParty") {
        this.hide["factoryName"] = true;
        this.hide["responsiblePartyOrganisation"] = true;
        if (this.search[valueName] != null) {
          // 1 = DESIGN // 2 = PRODUCTION // 3 = SUPPLIER
          if (this.search[valueName] === 3) {
            this.hide["factoryName"] = false;
          } else if (this.search[valueName] === 1) {
            this.hide["responsiblePartyOrganisation"] = false;
          }
        }
      }
    },
    fromArrayToSearchString(array) {
      var output = "";
      for (const value of array) {
        output += output == "" ? value : "," + value;
      }
      return output;
    },
    // changeIgnoreServiceLimitTimeButton() {
    //   if (this.search["ignoreServiceLimitTime"] == undefined) {
    //     this.search["ignoreServiceLimitTime"] = true;
    //   } else {
    //     this.search["ignoreServiceLimitTime"] =
    //       !this.search["ignoreServiceLimitTime"];
    //   }
    //   this.getAdvancedSearchData();
    // },
    arrayIsNotUndefinedOrArrayLengthIsNot0(array) {
      return array != undefined && array.length != 0;
    },
    addToSearch(data){
      this.search = { ...this.search, ...data}
    },
    download(){
      this.downloadLoading = true;
      this.refactorArraysToStrings();
      this.$api
        .downloadAdvancedSearchData(this.options, this.search, this.ignoreServiceLimitTime)
        .finally(() => (this.downloadLoading = false));

    }
  },
  mounted() {
    this.getAdvancedSearchSetup();
  },
  watch: {
    options: {
      handler() {
        this.getAdvancedSearchData();
      },
    },
  },
};
</script>
